import axios from 'axios';
import { wrapAxios } from '../../axios';
import { IPrice } from '@cuspar/ywt.ch.model';

export const priceAPI = {
  getPrices: async () => {
    return wrapAxios(() => axios.get<IPrice[]>(`/prices`));
  },
};
